var $ = require('../internals/export');

var $entries = require('../internals/object-to-array').entries; // `Object.entries` method
// https://tc39.github.io/ecma262/#sec-object.entries


$({
  target: 'Object',
  stat: true
}, {
  entries: function entries(O) {
    return $entries(O);
  }
});